<mat-card-title class="title-padding sp-title">
    DNS Setup<br>
</mat-card-title>
<div style="padding-left: 10px;padding-top: 20px;">
    
    <p>We recommend to update your DNS records to allow StayPrivate to send emails on behalf of your users. This means
        that emails sent via StayPrivate will appear as sent from the user's company email address, rather than from an
        spmail.com email address.</p>
    <p>Simply follow the instructions below to update your DNS records, and senders' email addresses will automatically
        be updated on all new emails.</p>

        <p  *ngIf="roundtrip">Please ensure that you have already setup your email server to work with StayPrivate before updating your DNS records.</p>

    

    <table class="dns-table-style">

        <tr class="dns-record-style">
            <td class="cell-title">SPF:</td>
            <td *ngIf="checkingSpf" class="cell-icon"> <mat-spinner diameter="20" style="margin: auto;"></mat-spinner>
            </td>
            <td *ngIf="!checkingSpf && spf" class="cell-icon"><mat-icon
                    style="color:#02b302; margin: auto;line-height: 30px;">done</mat-icon></td>
            <td *ngIf="!checkingSpf && !spf" class="cell-icon"><mat-icon
                    style="color:#da1c1c; margin: auto;line-height: 30px;">close</mat-icon></td>
            <td class="cell-reason">{{spfReason}}</td>

        </tr>
        <tr class="dns-record-style">
            <td class="cell-title">DKIM:</td>
            <td *ngIf="checkingDkim" class="cell-icon"> <mat-spinner diameter="20" style="margin: auto;"></mat-spinner>
            </td>
            <td *ngIf="!checkingDkim && dkim" class="cell-icon"><mat-icon
                    style="color:#02b302; margin: auto;line-height: 30px;">done</mat-icon></td>
            <td *ngIf="!checkingDkim && !dkim" class="cell-icon"><mat-icon
                    style="color:#da1c1c; margin: auto;line-height: 30px;">close</mat-icon></td>
            <td class="cell-reason">{{dkimReason}}</td>
        </tr>
    </table>
    <div class="dns-table-style" style="margin-top: 10px;">
        <button mat-stroked-button style="color: #1A47D6; border-color: #1A47D6; margin-bottom: 20px; right: 0px; padding: 0 50px;" (click)="checkDns()">
            Refresh
        </button>
        <!-- <button mat-flat-button color="primary" style="background-color: #1A47D6; margin-bottom: 20px;"
            (click)="checkDns()">Refresh</button> -->
    </div>

    <p>To update your SPF record:</p>
    <ul>
        <li *ngIf="spfReason=='Entry not found in SPF record'||spfReason==''||spfReason=='SPF looks good'">
            Find the current SPF record in your DNS administration console, and add the text: <span class="sp-copy"
                (click)="copy('include:spmail.com')">include:spmail.com</span> before
            the trailing '-all'.
        </li>
        <li *ngIf="spfReason=='Entry not found in SPF record'">
            Your new SPF record should look like: <br><span class="sp-copy"
                (click)="copy(spfNewRecord)">{{spfNewRecord}}</span>
        </li>
        <li *ngIf="spfReason=='SPF record not found'">
            You do not currently have an SPF record, in your DNS administration console, add a new TXT record with the
            following:
            <span class="sp-copy" (click)="copy('v=spf1 a mx include:spmail.com ~all')">v=spf1 a mx include:spmail.com
                ~all</span>.
        </li>
        <li *ngIf="spfReason=='SPF record is not valid'">
            Looks like there is an issue with the formatting of your SPF record. Make sure any includes are added before
            the
            ending -all.
        </li>
        <li>Save the DNS changes and click refresh to see if the entries have been added correctly and picked up
            successfully.
        </li>
    </ul>
    <p>To update your DKIM record:</p>
    <ul>
        <li>Add a new CNAME record called <span class="sp-copy"
                (click)="copy('stayprivate._domainkey')">stayprivate._domainkey</span> with the
            value: <span class="sp-copy"
                (click)="copy('stayprivate._domainkey.spmail.com')">stayprivate._domainkey.spmail.com</span>.
        </li>
        <li>Save the DNS changes and click refresh to see if the entries have been added correctly and picked up
            successfully.
        </li>
    </ul>
</div>